import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ISystemPaymentQuery,
  ITariffSystemPayment,
  TARIFF_SYSTEM_PAYMENTS,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class OnDemandComfortPaymentGateway {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly builder: RestCallBuilder<void, ITariffSystemPayment[]> =
    new RestCallBuilder<void, ITariffSystemPayment[]>([]);

  getSystemPayments(
    query: ISystemPaymentQuery
  ): Observable<IApiResponse<ITariffSystemPayment[]>> {
    const params: Record<string, string | number> = {
      tariffAreaId: query.tariffAreaId,
      externalReference: query.externalReference,
    };
    if (query.dateTime) {
      params['dateTime'] = query.dateTime;
    }

    return this.builder
      .getExternal(
        `${this.configService.get().general.tariffUrl}/tariff/system-payments`,
        params
      )
      .validate(
        API_RESPONSE_SCHEMA(TARIFF_SYSTEM_PAYMENTS),
        'OnDemandComfortPayment.getSystemPayments'
      )
      .handleMessages()
      .build();
  }
}
